import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSalaryHistory(userId) {
        try{            
            const response = await axios.get(`CompAllocation/${userId}/salary-history`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('CompAllocation api getSalaryHistory error')
            throw error
        }
    },
    async upsert(data) {
        try
        {            
            const response = await axios.post(`CompAllocation`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api upsert error')
            throw error
        }
    },
    async forReview(compensationId) {
        try
        {            
            const response = await axios.post(`CompAllocation/forReview/${compensationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api forReview error')
            throw error
        }
    },
    async approve(compensationId) {
        try
        {            
            const response = await axios.post(`CompAllocation/approve/${compensationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api approve error')
            throw error
        }
    },
    async reject(compensationId) {
        try
        {            
            const response = await axios.post(`CompAllocation/reject/${compensationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api reject error')
            throw error
        }
    },
    async delete(compensationId) {
        try
        {            
            const response = await axios.post(`CompAllocation/delete/${compensationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api delete error')
            throw error
        }
    },
    async undoDelete(compensationId) {
        try
        {            
            const response = await axios.post(`CompAllocation/undo_delete/${compensationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('CompAllocation api undoDelete error')
            throw error
        }
    },
}